export default "__VITE_ASSET__BtxUmJ1f__"